import * as React from "react";
import { cn } from "@/lib/utils";

interface SkipLinkProps {
  href?: string;
  children?: React.ReactNode;
  className?: string;
}

/**
 * SkipLink Component
 * 
 * A visually hidden link that becomes visible when focused.
 * Allows keyboard users to skip navigation and jump directly to main content.
 * This is a WCAG 2.2 AA requirement for accessibility.
 */
export function SkipLink({ 
  href = "#main-content", 
  children = "Skip to main content",
  className 
}: SkipLinkProps) {
  return (
    <a
      href={href}
      className={cn(
        // Visually hidden by default
        "sr-only",
        // Becomes visible when focused
        "focus:not-sr-only focus:fixed focus:top-4 focus:left-4 focus:z-[9999]",
        // Styling when visible
        "focus:px-4 focus:py-2 focus:bg-primary focus:text-primary-foreground",
        "focus:rounded-md focus:shadow-lg focus:outline-none",
        "focus:ring-2 focus:ring-ring focus:ring-offset-2",
        // Transition for smooth appearance
        "transition-all duration-200",
        className
      )}
    >
      {children}
    </a>
  );
}

export default SkipLink;
